<template>

  <div class="app-container" v-if="canList">
    <div class="filter-container">
      <el-input @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item input"
                placeholder="编号"
                v-model="listQuery.entity.accountRecharge.no">
      </el-input>
      <!--      <el-input @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item input"-->
      <!--                placeholder="用户ID"-->
      <!--                v-model="listQuery.entity.accountRecharge.userId">-->
      <!--      </el-input>-->
      <el-input @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item input"
                placeholder="用户名"
                v-model="listQuery.entity.accountRecharge.name">
      </el-input>
      <el-input @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item input"
                placeholder="用户编号"
                v-model="listQuery.entity.accountRecharge.code">
      </el-input>
      <!--      <el-input @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item input"-->
      <!--                placeholder="金额"-->
      <!--                v-model="listQuery.entity.accountRecharge.amount">-->
      <!--      </el-input>-->
      <!--      <el-input @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item input"-->
      <!--                placeholder="类型"-->
      <!--                v-model="listQuery.entity.accountRecharge.type">-->
      <!--      </el-input>-->
      <!--      <el-input @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item input"-->
      <!--                placeholder="信息"-->
      <!--                v-model="listQuery.entity.accountRecharge.info">-->
      <!--      </el-input>-->
      <el-select @change='handleFilter' clearable class="filter-item input" style="width: 130px"
                 v-model="listQuery.entity.accountRecharge.status"
                 placeholder="状态">
        <el-option v-for="(item,index) in  statusOptions" :key="item" :label="item" :value="index">
        </el-option>
      </el-select>
      <el-date-picker
          @change='handleFilter'
          value-format="yyyy-MM-dd HH:mm:ss"
          class="filter-item input"
          v-model="listQuery.entity.accountRecharge.times"
          type="datetimerange"
          range-separator="至"
          start-placeholder="时间开始日期"
          end-placeholder="时间结束日期">
      </el-date-picker>

      <div style="display: inline-block">

        <el-button style="margin-left: 10px;" class="filter-item" type="primary" v-waves icon="el-icon-search"
                   @click="handleFilter">查找
        </el-button>
        <!--        <el-button class="filter-item" style="margin-left: 10px;" @click="handleCreate" type="primary"-->
        <!--                   v-if="canSave" icon="el-icon-edit">添加-->
        <!--        </el-button>-->
        <el-button class="filter-item" type="primary" :loading="downloadLoading" v-waves icon="el-icon-download"
                   @click="handleDownload">导出
        </el-button>
        <!--        <el-button class="filter-item" type="primary" :loading="downloadLoading" v-waves icon="el-icon-upload2"-->
        <!--                   @click="()=>$refs.file.click()">导入-->
        <!--        </el-button>-->

        <input style="display: none" ref="file" @change="upload" type="file">
      </div>
    </div>

    <el-table :key='tableKey' :data="list" v-loading="listLoading" border fit highlight-current-row
              style="width: 100%;">
      <yf-table-column align="center" label="ID">
        <template slot-scope="scope">
          <span>{{ scope.row.accountRecharge.id }}</span>
        </template>
      </yf-table-column>
      <!--      <yf-table-column align="center" label="编号">-->
      <!--        <template slot-scope="scope">-->
      <!--          <span v-if="scope.row.accountRecharge">{{ scope.row.accountRecharge.no }}</span>-->
      <!--        </template>-->
      <!--      </yf-table-column>-->
      <!--      <yf-table-column align="center" label="用户ID">-->
      <!--        <template slot-scope="scope">-->
      <!--          <span v-if="scope.row.accountRecharge">{{ scope.row.accountRecharge.userId }}</span>-->
      <!--        </template>-->
      <!--      </yf-table-column>-->
      <yf-table-column align="center" label="用户名">
        <template slot-scope="scope">
          <span v-if="scope.row.accountRecharge">{{ scope.row.accountRecharge.name }}</span>
        </template>
      </yf-table-column>
      <yf-table-column align="center" label="用户编号">
        <template slot-scope="scope">
          <span v-if="scope.row.accountRecharge">{{ scope.row.accountRecharge.code }}</span>
        </template>
      </yf-table-column>
      <yf-table-column align="center" label="金额">
        <template slot-scope="scope">
          <span v-if="scope.row.accountRecharge">{{ scope.row.accountRecharge.amount }}</span>
        </template>
      </yf-table-column>
      <!--      <yf-table-column align="center" label="类型">-->
      <!--        <template slot-scope="scope">-->
      <!--          <span v-if="scope.row.accountRecharge">{{ scope.row.accountRecharge.type }}</span>-->
      <!--        </template>-->
      <!--      </yf-table-column>-->
      <yf-table-column align="center" label="信息">
        <template slot-scope="scope">
          <span v-if="scope.row.accountRecharge">{{ scope.row.accountRecharge.info }}</span>
        </template>
      </yf-table-column>
      <yf-table-column align="center" label="状态">
        <template slot-scope="scope">
                                                <span v-if="scope.row.accountRecharge">

                         <el-tag :type="tagTypes[scope.row.accountRecharge.status]"
                                 v-if="scope.row.accountRecharge.status!=null">     {{
                             statusOptions[scope.row.accountRecharge.status]
                           }}</el-tag>

                        </span>
        </template>
      </yf-table-column>
      <yf-table-column align="center" label="时间" width="160">
        <template slot-scope="scope">
          <span v-if="scope.row.accountRecharge">{{ parseTime(scope.row.accountRecharge.time) }}</span>
        </template>
      </yf-table-column>

<!--      <yf-table-column align="center" label="操作" width="230" class-name="small-padding fixed-width">-->
<!--        <template slot-scope="scope">-->
<!--          <el-button type="primary" v-if="canUpdate" size="mini" @click="handleUpdate(scope)">编辑</el-button>-->
<!--          <el-button v-if="canSave" size="mini" type="danger"-->
<!--                     @click="handleDelete(scope)">删除-->
<!--          </el-button>-->
<!--        </template>-->
<!--      </yf-table-column>-->

    </el-table>

    <div class="pagination-container" style="margin-top: 20px">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                     :current-page="listQuery.page" :page-sizes="[10,20,30, 50]" :page-size="listQuery.limit"
                     layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>

    <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible">
      <el-form :rules="rules" ref="dataForm" :model="temp" label-position="left" label-width="120px"
               style='width: 450px; margin-left:50px;'>
        <el-form-item label="编号" prop="accountRecharge.no">
          <el-input v-model="temp.accountRecharge.no"></el-input>
        </el-form-item>
        <el-form-item label="用户ID" prop="accountRecharge.userId">
          <el-input v-model="temp.accountRecharge.userId"></el-input>
        </el-form-item>
        <el-form-item label="用户名" prop="accountRecharge.name">
          <el-input v-model="temp.accountRecharge.name"></el-input>
        </el-form-item>
        <el-form-item label="用户编号" prop="accountRecharge.code">
          <el-input v-model="temp.accountRecharge.code"></el-input>
        </el-form-item>
        <el-form-item label="金额" prop="accountRecharge.amount">
          <el-input v-model="temp.accountRecharge.amount"></el-input>
        </el-form-item>
        <el-form-item label="类型" prop="accountRecharge.type">
          <el-input v-model="temp.accountRecharge.type"></el-input>
        </el-form-item>
        <el-form-item label="信息" prop="accountRecharge.info">
          <el-input v-model="temp.accountRecharge.info"></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="accountRecharge.status">
          <el-select class="filter-item" v-model="temp.accountRecharge.status" placeholder="状态">
            <el-option v-for="(item,index) in  statusOptions" :key="item" :label="item"
                       :value="index">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="时间" prop="accountRecharge.time">
          <el-date-picker v-model="temp.accountRecharge.time" type="datetime"
                          value-format="yyyy-MM-dd HH:mm:ss" placeholder="时间">
          </el-date-picker>
        </el-form-item>


      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialogForm">取消</el-button>
        <el-button v-if="dialogStatus=='create'" type="primary" @click="createData">确认</el-button>
        <el-button v-else type="primary" @click="updateData">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<style type="stylus">
.filter-container {
  /*padding-bottom: 20px;*/
}

.filter-item {
  margin-bottom: 10px;
}

.filter-item.input {
  /*line-height: 60px*/
  margin-right: 10px;
}
</style>

<script>
import {list, options, down, upload, info, save, update, remove} from '@/api/account_recharge'
import waves from '@/directive/waves' // 水波纹指令
import {downExcel} from '@/utils/down.js'
import {parseTime} from '@/utils'


import {mapGetters} from 'vuex'
import {hasAuth} from '@/utils/auth'

export default {
  name: 'test',
  directives: {
    waves
  },
  components: {},
  data() {
    return {
      tableKey: 0,
      list: null,
      total: null,
      listLoading: true,
      time: null
      ,
      listQuery: {
        page: 1,
        limit: 20,
        order: 'accountRecharge.id desc',
        entity: {
          accountRecharge:
              {
                id: null,
                no: null,
                userId: null,
                name: null,
                code: null,
                amount: null,
                type: null,
                info: null,
                time: null,
                status: null
              }
        }
      },
      statusOptions: [],
      tagTypes: ['info', '', 'warning', 'danger', 'warning'],
      temp: {

        accountRecharge:
            {
              id: null,
              no: null,
              userId: null,
              name: null,
              code: null,
              amount: null,
              type: null,
              info: null,
              time: null,
              status: null
            }


      }
      ,
      dialogFormVisible: false,
      dialogStatus: '',
      textMap: {
        update: '修改',
        create: '新增'
      },
      rules:
          {
            'accountRecharge.no': [
              {
                required: false,
                message: '必填字段',
                trigger: 'change'
              }
            ]
            ,
            'accountRecharge.userId': [
              {
                required: false,
                message: '必填字段',
                trigger: 'change'
              }
            ]
            ,
            'accountRecharge.name': [
              {
                required: false,
                message: '必填字段',
                trigger: 'change'
              }
            ]
            ,
            'accountRecharge.code': [
              {
                required: false,
                message: '必填字段',
                trigger: 'change'
              }
            ]
            ,
            'accountRecharge.amount': [
              {
                required: false,
                message: '必填字段',
                trigger: 'change'
              }
            ]
            ,
            'accountRecharge.type': [
              {
                required: false,
                message: '必填字段',
                trigger: 'change'
              }
            ]
            ,
            'accountRecharge.info': [
              {
                required: false,
                message: '必填字段',
                trigger: 'change'
              }
            ]
            ,
            'accountRecharge.time': [
              {
                required: false,
                message: '必填字段',
                trigger: 'change'
              }
            ]
            ,
            'accountRecharge.status': [
              {
                required: false,
                message: '必填字段',
                trigger: 'blur'
              }
            ]
          }
      ,
      downloadLoading: false,
      qData:
          {
            token: '',
            key: ''
          }
    }
  },
  activated() {
    this.getList()
    this.getOptions()
  },
  computed: {
    ...mapGetters([
      'perms'
    ]),
    canSave() {
      return hasAuth(this.perms, 'account:recharge:save')
    },
    canDelete() {
      return hasAuth(this.perms, 'account:recharge:delete')
    },
    canUpdate() {
      return hasAuth(this.perms, 'account:recharge:update')
    },
    canList() {
      return hasAuth(this.perms, 'account:recharge:list')
    }
  },
  methods: {
    parseTime(time) {
      if (!time) return ''
      return parseTime(time, '{y}-{m}-{d} {h}:{i}:{s}')
    },
    getList() {
      this.listLoading = true
      list(this.listQuery).then(response => {
        this.list = response.data.list
        this.total = response.data.total
        this.listLoading = false
      })
    },
    getOptions() {
      options().then(res => {
        this.statusOptions = res.data.statusOptions
      })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.getList()
    },
    handleModifyStatus(row, status) {
      this.$message({
        message: '操作成功',
        type: 'success'
      })
      row.status = status
    },
    beforeFormShow(row) {
      this.resetTemp(row) // 更新数据
    },
    afterFormShow(row) {

    },
    beforeFormCommit() {

    },
    resetTemp(row) {
      this.temp = {
        accountRecharge: {}
      }
      if (row) {
        this.temp = Object.assign({}, row) // copy obj
      }

    },
    handleCreate() {
      this.beforeFormShow()
      this.dialogStatus = 'create'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.afterFormShow()
        this.$refs['dataForm'].clearValidate()
      })
    },
    handleDelete(scope) {
      this.index = scope.$index
      // this.beforeFormShow(scope.row)
      // this.temp = Object.assign({}, row) // copy obj
      this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // this.$message({
        //   type: 'success',
        //   message: '删除成功!'
        // })
        this.deleteData()
      }).catch(() => {
        this.$message({
          type: 'error',
          message: '删除失败'
        })
      })
    },
    createData() {
      this.$refs['dataForm'].validate((valid) => {
            if (valid) {
              this.beforeFormCommit()
              save(this.temp).then(res => {
                this.temp = res.data
                // this.list.unshift(this.temp)
                this.getList()
                this.closeDialogForm()
                this.$notify({
                  title: '成功',
                  message: '创建成功',
                  type: 'success',
                  duration: 2000
                })
              })
            }
          }
      )
    },
    deleteData() {
      // const ids = [this.temp.accountRecharge.id]
      const ids = [this.list[this.index].accountRecharge.id]
      remove({ids: ids}).then(res => {
        // 从当前队列中移除
        this.list.splice(this.index, 1)
        this.$notify({
          title: '成功',
          message: '删除成功',
          type: 'success',
          duration: 2000
        })
      })
    },
    handleUpdate(scope) {
      this.beforeFormShow(scope.row)
      info(scope.row.accountRecharge.id).then(res => {
        this.temp = res.data
        this.dialogStatus = 'update'
        this.dialogFormVisible = true
        this.$nextTick(() => {
          this.$refs['dataForm'].clearValidate()
        })
      })
    },
    updateData() {
      this.$refs['dataForm'].validate((valid) => {
            if (valid) {
              this.beforeFormCommit()
              update(this.temp).then(() => {
                // this.list.splice(this.index, 1, this.temp)
                this.getList()
                this.closeDialogForm()
                this.$notify({
                  title: '成功',
                  message: '更新成功',
                  type: 'success',
                  duration: 2000
                })
              })
            }
          }
      )
    },
    closeDialogForm() {
      this.dialogFormVisible = false
    },
    upload(e) {
      upload(e.target.files[0]).then(res => {
        this.$notify({
          title: '成功',
          message: '上传成功!',
          type: 'success',
          duration: 2000
        })
        this.getList()
      })
    },
    handleDownload() {
      this.downloadLoading = true
      down(this.listQuery).then(res => {
        downExcel(res)
        this.downloadLoading = false
        this.$notify({
          title: '成功',
          message: '下载成功',
          type: 'success',
          duration: 2000
        })
      })
    },
    // formatJson(filterVal, jsonData) {
    //     return jsonData.map(v => filterVal.map(j => {
    //         return v[j]
    //     }
    // ))
    // },
  }
}
</script>
